import React, { useState, useEffect } from 'react';
import { useQuery, useMutation } from "react-query";

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import * as helpers from '../../utils/utils.js';
import "./slotModal.css"

import { useSelections } from '../../hooks/useSelections.js';
import { usePrices } from '../../hooks/usePrices.js';
import { useUnits } from '../../hooks/useUnits.js';
import { useSlots } from '../../hooks/useSlots.js';



function SlotModal({ isOpen, onClose, onSave }) {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [availableSlots, setAvailableSlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState(null);

  const { fetchDateSlots } = useSelections();


  useEffect(() => {

    let utcDate = new Date(selectedDate);
    utcDate.setUTCHours(0, 0, 0, 0);
    const utcDateValue = utcDate.valueOf();
    fetchDateSlots(utcDateValue, "available").then((slots) => {
      setAvailableSlots(slots);
    }
    ).catch((error) => {
      console.error("Error fetching slots:", error);
    }
    );
  }, [selectedDate, fetchDateSlots]);


  const handleSlotClick = (slot) => {
    if (selectedSlot?.id === slot.id) {
      setSelectedSlot(null);
    } else {
      setSelectedSlot(slot);
    }
  }

  const handleClose = () => {
    setSelectedSlot(null);
    setSelectedDate(null);
    setAvailableSlots([]);
    onClose();
  }



  const handleSubmit = async () => {
    if (selectedSlot) {
      onSave(selectedSlot);
    }
    handleClose();
  };

  return (
    <Modal show={isOpen} onHide={() => handleClose()} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>

      <label htmlFor="date" className="form-label">Select a date:</label>
      <input
        type="date"
        id="date"
        className="form-control"
        value={selectedDate}
        onChange={(e) => setSelectedDate(e.target.value)}
      />

      <table className="table slot-table">
        <thead>
          <tr>
          <th scope="col">Unit</th>
          <th scope="col">Time</th>
          <th scope="col">Price</th>
          </tr>
        </thead>
        <tbody>

        {availableSlots.length > 0 && availableSlots.map((slot) => {

          return (
            <SlotItem key={slot.id} slot={slot} onSelect={() => handleSlotClick(slot)} isSelected={slot.id === selectedSlot?.id}/>
          )})}
        
        </tbody>
      </table>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => handleClose()}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SlotModal;

function SlotItem({ slot, onSelect, isSelected }) {
  const { retrieveUnitById } = useUnits();
  const { retrievePriceById } = usePrices();

  const {
    data: unit,
    error: unitError,
    isLoading: unitIsLoading,
  } = useQuery(["unitData", slot.priceId], () => retrieveUnitById(slot.unitId), {
    staleTime: 1000 * 60 * 30,          // 30 minutes
    refetchOnWindowFocus: false,        // prevent re-fetch on tab switch
    cacheTime: 1000 * 60 * 60,          // 1 hour cache
  });

  const {
    data: price,
    error: priceError,
    isLoading: priceIsLoading,
  } = useQuery(["priceData", slot.priceId], () => retrievePriceById(slot.priceId), {
    staleTime: 1000 * 60 * 30,          // 30 minutes
    refetchOnWindowFocus: false,        // prevent re-fetch on tab switch
    cacheTime: 1000 * 60 * 60,          // 1 hour cache
  });


  if (unitIsLoading || priceIsLoading) return <p>Loading...</p>;
  if (unitError) return <p>Error: {unitError.message}</p>;
  if (priceError) return <p>Error: {priceError.message}</p>;

  return (
    <tr className="add-slot-row">
    <td className='unit'>{unit.name}</td>
    <td className='time'>{helpers.formatTimeRange(price.startTime.hours, price.startTime.minutes, price.duration)}</td>
    <td className='price'>{price.price}</td>
    <td className='selected'>
      <input
        type="checkbox"
        checked={isSelected}
        onChange={() => onSelect()}
        onClick={(e) => e.stopPropagation()} // Prevent row click triggering checkbox twice
      />
    </td>
    </tr>
  );
}